import React, { useState } from "react";
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { NavLink, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import withServices from "../hocs/withServices";

function ResetPassword({ services }) {
  const history = useHistory();
  const { register, handleSubmit } = useForm();
  const [errorMessage, setErrorMessage] = useState('');
  
  const onSubmit = (data) => {
    services.auth.resetPassword(data)
      .then(() => {
        alert('На вашу почту выслана ссылка для полного восстановления аккаунта');
        history.push("/");
      })
      .catch(() => setErrorMessage('Данной почты не существует'));
  };

  const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: theme.spacing(1),
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
  }));

  const classes = useStyles();

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <div>
          <img src="/aitu-logo.png"alt="logo" />
        </div>

        <Typography component="h1" variant="h5">
          Новый пароль
        </Typography>

        {errorMessage && (
          <Typography variant="body1" color="error">
            {errorMessage}
          </Typography>
        )}

        <form onSubmit={handleSubmit(onSubmit)} className={classes.form} noValidate>
          <TextField
            {...register("email")}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Почта"
            name="email"
            autoComplete="email"
            autoFocus
          />

          <TextField
            {...register("password")}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Новый пароль"
            type="password"
            id="password"
            autoComplete="current-password"
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Сбросить пароль
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href="/login" variant="body2">
                Вернуться на страницу авторизации
              </Link>
            </Grid>
            <Grid item>
              <div>
                <NavLink to={'/registration'} className='nav-link'>Регистрация</NavLink>
              </div>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://astanait.edu.kz/">
        Astana IT University
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default withServices()(ResetPassword);